import { useEffect, useState, useContext } from "react"
import { contract, DAO_REWARD, DEFAULT_CHAIN } from "./constant";
import { MulticallContractWeb3 } from "../hooks/useContracts";
import { toast } from "react-toastify";
import { getNFTContract, getDaoContract, getWalletNFTDetails, getDaoRewardContract, getWeb3Contract, getDaoRewardETHContract } from "./contractHelper";
import { Context } from "../context/context";
import { useAccount } from "wagmi";
import { getWeb3 } from "./connectors";
import tokenAbi from '../json/token.json';


export const useAccountStats = (updater) => {
    let { setProgress } = useContext(Context);
    const { address: account } = useAccount();


    const [stats, setStats] = useState({
        eth_price: 0,
        carbon_price: 0,
        token_balance: 0,
        user_nft: [],
        nft_balance: 0,
        holdingWorth: 0,
        isAdmin: false,
        votingWeights: 0
    });


    const daoContract = getDaoContract();
    const web3 = getWeb3()


    useEffect(() => {
        const fetch = async () => {
            setProgress(40)
            try {

                const nftData = await MulticallContractWeb3(
                    [
                        daoContract.methods.getVotingWeightLength(), //0
                        daoContract.methods.getVotingWeight(account), //1
                        daoContract.methods.getPower(), //2
                        daoContract.methods.owner() //3
                    ]
                )

                setProgress(50)

                let calls = [];
                for (let i = 0; i < nftData[0]; i++) {
                    let nftContract = getNFTContract(contract[DEFAULT_CHAIN].NFT_ADDRESS[i])
                    calls[i] = nftContract.methods.balanceOf(account);
                }

                const testData = await MulticallContractWeb3(calls);


                let bstBalance = web3.utils.fromWei(await web3.eth.getBalance(account));
                let bstPrice = 0.094;

                setStats({
                    eth_price: bstBalance,
                    carbon_price: bstPrice,
                    token_balance: bstBalance,
                    user_nft: testData,
                    nft_balance: testData && testData.length > 0 ? testData.reduce((total, val) => parseInt(total) + parseInt(val)) : 0,
                    holdingWorth: bstPrice * bstBalance,
                    isAdmin: nftData[3] && nftData[3].toString().toLowerCase() === account.toString().toLowerCase() ? true : false,
                    votingWeights: nftData[1]
                })

                setProgress(100)
            }
            catch (err) {
                console.log(err.message);
                toast.error(err.reason);
                setProgress(100)

            }
        }

        if (account) {
            fetch();
        }
        else {
            setProgress(100)
            setStats({
                eth_price: 0,
                carbon_price: 0,
                token_balance: 0,
                user_nft: [],
                nft_balance: 0,
                holdingWorth: 0,
                isAllowedMembers: false,
                isAdmin: false,
                votingWeights: 0

            })
        }
        // eslint-disable-next-line
    }, [updater, account]);

    return stats;
}

export const useDaoRewardStats = (updater) => {
    const { address } = useAccount();

    const [stats, setStats] = useState({
        getRewardtokens: [],
        getUserReward: [],
        tokensybol: [],
        tokendecimals: [],
        finalData: []
    });

    const daoRewardContract = getDaoRewardContract();

    useEffect(() => {
        const fetch = async () => {
            try {
                // Fetch reward tokens and user rewards
                const data = await MulticallContractWeb3(
                    [
                        daoRewardContract.methods.getRewardtokens(),
                        daoRewardContract.methods.getUserReward(address),
                    ]
                );

                let tokensybol = [];
                let tokendecimals = [];

                if (data[0] && data[0].length > 0) {
                    // Map through all tokens
                    for (let i = 0; i < data[0].length; i++) {
                        const tokenAddress = data[0][i];

                        // Check if the token address is 0x000...000 (ETH case)
                        if (tokenAddress === "0x0000000000000000000000000000000000000000") {
                            tokensybol.push("BST"); // Set symbol to ETH
                            tokendecimals.push(18); // Set decimals to 18
                        } else {
                            // Fetch token symbol and decimals for non-ETH tokens
                            const tokenContract = getWeb3Contract(tokenAbi, tokenAddress);

                            const symbolCall = tokenContract.methods.symbol();
                            const decimalsCall = tokenContract.methods.decimals();

                            const [symbol, decimals] = await MulticallContractWeb3([symbolCall, decimalsCall]);

                            tokensybol.push(symbol);
                            tokendecimals.push(decimals);
                        }
                    }
                }

                const finalData = data[0].map((items, key) => {
                    return {
                        symbol: tokensybol[key],
                        balance: data[1][key] / Math.pow(10, tokendecimals[key])
                    }
                }).filter((items) => {
                    return parseFloat(items.balance) > 0
                })



                // Update the state with fetched data
                setStats({
                    getRewardtokens: data[0],
                    getUserReward: data[1],
                    tokensybol,
                    tokendecimals,
                    finalData
                });

            } catch (err) {
                console.log(err.message);
                toast.error(err.reason);
            }
        };

        if (address) {
            fetch();
        } else {
            setStats({
                getRewardtokens: [],
                getUserReward: [],
                tokensybol: [],
                tokendecimals: [],
                finalData: []
            });
        }

        // eslint-disable-next-line
    }, [updater, address]);

    return stats;
};

export const useAccountNftStats = (updater) => {
    const { address: account } = useAccount();

    const [stats, setStats] = useState({
        nft_list: [],
        getPower: [],
        loading: true
    });


    const daoContract = getDaoContract();

    useEffect(() => {
        const fetch = async () => {

            try {

                const nftData = await MulticallContractWeb3(
                    [
                        daoContract.methods.getPower(), //0
                        daoContract.methods.getVotingWeightLength() //1
                    ]
                );

                let nftList = [];

                if (nftData[0]) {
                    for (let i = 0; i < nftData[1]; i++) {
                        const res = await getWalletNFTDetails(account, contract[DEFAULT_CHAIN].NFT_ADDRESS[i]);
                        if (res && res.data) {
                            nftList.push(...res.data);
                        }
                    }

                }

                setStats({
                    nft_list: nftList,
                    getPower: nftData[0],
                    loading: false
                })

            }
            catch (err) {
                console.log(err.message);
                toast.error(err.reason);


            }
        }

        if (account) {
            fetch();
        }
        else {
            setStats({
                nft_list: [],
                getPower: [],
                loading: true
            })
        }
        // eslint-disable-next-line
    }, [updater, account]);

    return stats;
}

export const useDaoBscRewardStats = (updater) => {
    const { address } = useAccount();
    const chainId = 56;
    const [stats, setStats] = useState({
        getRewardtokens: [],
        getUserReward: [],
        tokensybol: [],
        tokendecimals: [],
        finalData: []
    });

    const daoRewardContract = getDaoRewardETHContract(chainId, DAO_REWARD[chainId].RPC_URL);

    useEffect(() => {
        const fetch = async () => {
            try {
                // Fetch reward tokens and user rewards
                const data = await MulticallContractWeb3(
                    [
                        daoRewardContract.methods.getRewardtokens(),
                        daoRewardContract.methods.getUserReward(address),
                    ], DAO_REWARD[chainId].RPC_URL, DAO_REWARD[chainId].MULTICALL_ADDRESS
                );

                let tokensybol = [];
                let tokendecimals = [];

                if (data[0] && data[0].length > 0) {
                    // Map through all tokens
                    for (let i = 0; i < data[0].length; i++) {
                        const tokenAddress = data[0][i];

                        // Check if the token address is 0x000...000 (ETH case)
                        if (tokenAddress === "0x0000000000000000000000000000000000000000") {
                            tokensybol.push("BNB"); // Set symbol to ETH
                            tokendecimals.push(18); // Set decimals to 18
                        } else {
                            // Fetch token symbol and decimals for non-ETH tokens
                            const tokenContract = getWeb3Contract(tokenAbi, tokenAddress, DAO_REWARD[chainId].RPC_URL);

                            const symbolCall = tokenContract.methods.symbol();
                            const decimalsCall = tokenContract.methods.decimals();

                            const [symbol, decimals] = await MulticallContractWeb3([symbolCall, decimalsCall], DAO_REWARD[chainId].RPC_URL, DAO_REWARD[chainId].MULTICALL_ADDRESS);

                            tokensybol.push(symbol);
                            tokendecimals.push(decimals);
                        }
                    }
                }

                const finalData = data[0].map((items, key) => {
                    return {
                        symbol: tokensybol[key],
                        balance: data[1][key] / Math.pow(10, tokendecimals[key])
                    }
                }).filter((items) => {
                    return parseFloat(items.balance) > 0
                })



                // Update the state with fetched data
                setStats({
                    getRewardtokens: data[0],
                    getUserReward: data[1],
                    tokensybol,
                    tokendecimals,
                    finalData
                });

            } catch (err) {
                console.log(err.message);
                toast.error(err.reason);
            }
        };

        if (address) {
            fetch();
        } else {
            setStats({
                getRewardtokens: [],
                getUserReward: [],
                tokensybol: [],
                tokendecimals: [],
                finalData: []
            });
        }

        // eslint-disable-next-line
    }, [updater, address]);

    return stats;
};

export const useDaoEthRewardStats = (updater) => {
    const { address } = useAccount();
    const chainId = 11155111;
    const [stats, setStats] = useState({
        getRewardtokens: [],
        getUserReward: [],
        tokensybol: [],
        tokendecimals: [],
        finalData: []
    });

    const daoRewardContract = getDaoRewardETHContract(chainId, DAO_REWARD[chainId].RPC_URL);

    useEffect(() => {
        const fetch = async () => {
            try {
                // Fetch reward tokens and user rewards
                const data = await MulticallContractWeb3(
                    [
                        daoRewardContract.methods.getRewardtokens(),
                        daoRewardContract.methods.getUserReward(address),
                    ], DAO_REWARD[chainId].RPC_URL, DAO_REWARD[chainId].MULTICALL_ADDRESS
                );

                let tokensybol = [];
                let tokendecimals = [];

                if (data[0] && data[0].length > 0) {
                    // Map through all tokens
                    for (let i = 0; i < data[0].length; i++) {
                        const tokenAddress = data[0][i];

                        // Check if the token address is 0x000...000 (ETH case)
                        if (tokenAddress === "0x0000000000000000000000000000000000000000") {
                            tokensybol.push("ETH"); // Set symbol to ETH
                            tokendecimals.push(18); // Set decimals to 18
                        } else {
                            // Fetch token symbol and decimals for non-ETH tokens
                            const tokenContract = getWeb3Contract(tokenAbi, tokenAddress, DAO_REWARD[chainId].RPC_URL);

                            const symbolCall = tokenContract.methods.symbol();
                            const decimalsCall = tokenContract.methods.decimals();

                            const [symbol, decimals] = await MulticallContractWeb3([symbolCall, decimalsCall], DAO_REWARD[chainId].RPC_URL, DAO_REWARD[chainId].MULTICALL_ADDRESS);

                            tokensybol.push(symbol);
                            tokendecimals.push(decimals);
                        }
                    }
                }

                const finalData = data[0].map((items, key) => {
                    return {
                        symbol: tokensybol[key],
                        balance: data[1][key] / Math.pow(10, tokendecimals[key])
                    }
                }).filter((items) => {
                    return parseFloat(items.balance) > 0
                })



                // Update the state with fetched data
                setStats({
                    getRewardtokens: data[0],
                    getUserReward: data[1],
                    tokensybol,
                    tokendecimals,
                    finalData
                });

            } catch (err) {
                console.log(err.message);
                toast.error(err.reason);
            }
        };

        if (address) {
            fetch();
        } else {
            setStats({
                getRewardtokens: [],
                getUserReward: [],
                tokensybol: [],
                tokendecimals: [],
                finalData: []
            });
        }

        // eslint-disable-next-line
    }, [updater, address]);

    return stats;
};


export const useUserClaimedRewardStats = (chainId = 5512) => {
    const { address } = useAccount();
    const [stats, setStats] = useState({
        getRewardtokens: [],
        getUserReward: [],
        tokensybol: [],
        tokendecimals: [],
        finalData: []
    });

    const daoRewardContract = getDaoRewardETHContract(chainId, DAO_REWARD[chainId].RPC_URL);

    useEffect(() => {
        const fetch = async () => {
            try {
                // Fetch reward tokens and user rewards
                const data = await MulticallContractWeb3(
                    [
                        daoRewardContract.methods.getRewardtokens(),
                        daoRewardContract.methods.getUserClaimedRewards(address),
                    ], DAO_REWARD[chainId].RPC_URL, DAO_REWARD[chainId].MULTICALL_ADDRESS
                );


                let tokensybol = [];
                let tokendecimals = [];

                if (data[0] && data[0].length > 0) {
                    // Map through all tokens
                    for (let i = 0; i < data[0].length; i++) {
                        const tokenAddress = data[0][i];

                        // Check if the token address is 0x000...000 (ETH case)
                        if (tokenAddress === "0x0000000000000000000000000000000000000000") {
                            tokensybol.push(DAO_REWARD[chainId].symbol); // Set symbol to ETH
                            tokendecimals.push(18); // Set decimals to 18
                        } else {
                            // Fetch token symbol and decimals for non-ETH tokens
                            const tokenContract = getWeb3Contract(tokenAbi, tokenAddress, DAO_REWARD[chainId].RPC_URL);

                            const symbolCall = tokenContract.methods.symbol();
                            const decimalsCall = tokenContract.methods.decimals();

                            const [symbol, decimals] = await MulticallContractWeb3([symbolCall, decimalsCall], DAO_REWARD[chainId].RPC_URL, DAO_REWARD[chainId].MULTICALL_ADDRESS);

                            tokensybol.push(symbol);
                            tokendecimals.push(decimals);
                        }
                    }
                }

                const finalData = data[0].map((items, key) => {
                    return {
                        symbol: tokensybol[key],
                        balance: data[1][key] / Math.pow(10, tokendecimals[key])
                    }
                }).filter((items) => {
                    return parseFloat(items.balance) > 0
                })



                // Update the state with fetched data
                setStats({
                    getRewardtokens: data[0],
                    getUserReward: data[1],
                    tokensybol,
                    tokendecimals,
                    finalData
                });

            } catch (err) {
                console.log(err.message);
                toast.error(err.reason);
            }
        };

        if (address) {
            fetch();
        } else {
            setStats({
                getRewardtokens: [],
                getUserReward: [],
                tokensybol: [],
                tokendecimals: [],
                finalData: []
            });
        }

        // eslint-disable-next-line
    }, [address, chainId]);

    return stats;
};


export const useClaimedRewardStats = (chainId = 5512) => {
    const [stats, setStats] = useState({
        getRewardtokens: [],
        getUserReward: [],
        tokensybol: [],
        tokendecimals: [],
        finalData: []
    });

    const daoRewardContract = getDaoRewardETHContract(chainId, DAO_REWARD[chainId].RPC_URL);

    useEffect(() => {
        const fetch = async () => {
            try {
                // Fetch reward tokens and user rewards
                const data = await MulticallContractWeb3(
                    [
                        daoRewardContract.methods.getRewardtokens(),
                        daoRewardContract.methods.getTotalClaimedRewards(),
                    ], DAO_REWARD[chainId].RPC_URL, DAO_REWARD[chainId].MULTICALL_ADDRESS
                );


                let tokensybol = [];
                let tokendecimals = [];

                if (data[0] && data[0].length > 0) {
                    // Map through all tokens
                    for (let i = 0; i < data[0].length; i++) {
                        const tokenAddress = data[0][i];

                        // Check if the token address is 0x000...000 (ETH case)
                        if (tokenAddress === "0x0000000000000000000000000000000000000000") {
                            tokensybol.push(DAO_REWARD[chainId].symbol); // Set symbol to ETH
                            tokendecimals.push(18); // Set decimals to 18
                        } else {
                            // Fetch token symbol and decimals for non-ETH tokens
                            const tokenContract = getWeb3Contract(tokenAbi, tokenAddress, DAO_REWARD[chainId].RPC_URL);

                            const symbolCall = tokenContract.methods.symbol();
                            const decimalsCall = tokenContract.methods.decimals();

                            const [symbol, decimals] = await MulticallContractWeb3([symbolCall, decimalsCall], DAO_REWARD[chainId].RPC_URL, DAO_REWARD[chainId].MULTICALL_ADDRESS);

                            tokensybol.push(symbol);
                            tokendecimals.push(decimals);
                        }
                    }
                }

                const finalData = data[0].map((items, key) => {
                    return {
                        symbol: tokensybol[key],
                        balance: data[1][key] / Math.pow(10, tokendecimals[key])
                    }
                }).filter((items) => {
                    return parseFloat(items.balance) > 0
                })



                // Update the state with fetched data
                setStats({
                    getRewardtokens: data[0],
                    getUserReward: data[1],
                    tokensybol,
                    tokendecimals,
                    finalData
                });

            } catch (err) {
                console.log(err.message);
                toast.error(err.reason);
            }
        };


        fetch();


        // eslint-disable-next-line
    }, [chainId]);

    return stats;
};
